// Saves a file without leaving the page: a new tab opened without a click is
// blocked as a pop-up, and navigating the app itself would run its unload
// handlers. A ZIP is nothing a browser can display, so the frame only
// downloads it.
export const saveFile = (url: string) => {
  const frame = document.createElement('iframe');
  frame.style.display = 'none';
  frame.src = url;
  document.body.appendChild(frame);
  setTimeout(() => frame.remove(), 60 * 1000);
};
